import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  ArrowUpRight, Award, BookOpen, CalendarDays, Check, Compass, Eye,
  Fingerprint, Footprints, GraduationCap, Hand, HeartHandshake, Layers,
  MapPin, ScrollText, Sparkles, Users,
} from "lucide-react";
import { Reveal } from "../components/Reveal";

/* ————————————————————————————————————————————————
   INFOS MODIFIABLES — à ajuster facilement ici
———————————————————————————————————————————————— */
const WA =
  "https://wa.me/33623502131?text=Bonjour%20Julie%2C%20je%20suis%20int%C3%A9ress%C3%A9e%20par%20la%20formation%20R%C3%A9flexologie%20plantaire%2C%20peux-tu%20m%27envoyer%20les%20infos%20%3F";
const CONTACT = "/contact?soin=formation-reflexologie-plantaire";

const HERO_IMG = "/images/reflexologie.jpg";
const JULIE_IMG = "/images/portrait-cnt.jpg";
const PRATIQUE_IMG = "/images/reflexo-pratique.jpg";

const TARIF = "1 100 €";

const INFOS = [
  { icon: CalendarDays, label: "Durée", value: "5 jours" },
  { icon: CalendarDays, label: "Dates", value: "Du 23 au 28 novembre 2026", note: "ou en 2 week-ends (3 jours + 2 jours)" },
  { icon: MapPin, label: "Lieu", value: "Bayonne" },
  { icon: Users, label: "Participants", value: "4 participants" },
  { icon: GraduationCap, label: "Niveau", value: "Aucun prérequis" },
  { icon: Award, label: "Certificat", value: "Délivré en fin de formation" },
];

/* ———————————————————————————————————————————————— */

const POUR_QUI = [
  { icon: HeartHandshake, label: "Vous êtes thérapeute et souhaitez enrichir votre pratique." },
  { icon: Hand, label: "Vous pratiquez déjà le massage ou les soins corporels." },
  { icon: Sparkles, label: "Vous souhaitez acquérir une nouvelle compétence manuelle." },
  { icon: Compass, label: "Vous êtes en reconversion professionnelle." },
  { icon: Footprints, label: "Vous voulez apprendre une technique concrète et incarnée." },
  { icon: GraduationCap, label: "Vous avez simplement envie de prendre soin autrement." },
];

const APPRENTISSAGES = [
  { icon: BookOpen, title: "Découverte de la réflexologie", text: "Histoire, principes et fondements d'une pratique manuelle à l'écoute du corps." },
  { icon: Layers, title: "Anatomie & physiologie", text: "Les bases anatomiques du pied et les grandes fonctions du corps." },
  { icon: Fingerprint, title: "Cartographie des zones réflexes", text: "Apprendre à situer et reconnaître les différentes zones réflexes du pied." },
  { icon: Compass, title: "Correspondances", text: "Relier les zones du pied aux grandes fonctions et systèmes du corps." },
  { icon: Hand, title: "Techniques de toucher", text: "Pression, rythme, qualité du geste : le toucher qui rend la séance juste." },
  { icon: Eye, title: "Observation & écoute du pied", text: "Regarder, palper, sentir — développer un regard attentif et présent." },
  { icon: Footprints, title: "Déroulement d'une séance", text: "Installation du praticien et du receveur, construction d'une séance cohérente." },
  { icon: ScrollText, title: "Intégrer la pratique", text: "Des repères pour intégrer la réflexologie dans une démarche professionnelle." },
];

const EMPORTEZ = [
  { icon: Hand, title: "Une technique", text: "pour pratiquer la réflexologie plantaire." },
  { icon: Fingerprint, title: "Des gestes", text: "que vous pourrez reproduire avec confiance." },
  { icon: Footprints, title: "Une meilleure lecture du pied", text: "et de ses différentes zones réflexes." },
  { icon: Sparkles, title: "De l'expérience pratique", text: "grâce aux exercices réalisés pendant la formation." },
  { icon: HeartHandshake, title: "Une nouvelle relation au corps", text: "une autre manière d'entrer en lien à travers le toucher." },
];

const TEMOIGNAGES = [
  { name: "[À COMPLÉTER]", text: "[Emplacement de témoignage — à remplacer par un retour authentique de participant.]" },
  { name: "[À COMPLÉTER]", text: "[Emplacement de témoignage — à remplacer par un retour authentique de participant.]" },
  { name: "[À COMPLÉTER]", text: "[Emplacement de témoignage — à remplacer par un retour authentique de participant.]" },
];

const FAQ = [
  { q: "À qui s'adresse cette formation ?", a: "À toute personne souhaitant apprendre une technique manuelle concrète : thérapeutes, praticiens du bien-être, personnes en reconversion, ou simplement curieux d'apprendre à prendre soin autrement." },
  { q: "Faut-il avoir déjà pratiqué le massage ?", a: "Non. Chaque geste est expliqué, montré, puis expérimenté ensemble. L'essentiel est l'envie d'apprendre et de développer la qualité de son toucher." },
  { q: "Est-ce accessible aux débutants ?", a: "Oui, totalement. Aucun prérequis n'est demandé : la formation part des bases et laisse une large place à la pratique guidée." },
  { q: "Combien de personnes participent à la formation ?", a: "La formation se déroule en tout petit groupe — 4 participants — pour un accompagnement personnalisé et un temps de pratique important." },
  { q: "Que faut-il apporter ?", a: "Une tenue confortable et l'envie d'expérimenter. Le nécessaire à la pratique est indiqué avant le début de la formation." },
  { q: "La formation comprend-elle de la pratique ?", a: "Oui, largement. On n'apprend pas la réflexologie en regardant faire : les participants donnent, reçoivent, corrigent leur posture et affinent leur toucher tout au long des journées." },
  { q: "Reçoit-on un support pédagogique ?", a: "Oui — un livret de formation vous est remis pour accompagner votre pratique pendant et après la formation." },
  { q: "Un certificat est-il remis ?", a: "Oui — un certificat de formation vous est délivré à la fin des 5 jours." },
  { q: "Peut-on utiliser la réflexologie dans son activité professionnelle ?", a: "La formation transmet des bases pratiques et des repères concrets pour intégrer la réflexologie dans une démarche de bien-être et d'accompagnement corporel." },
  { q: "Comment s'inscrire ?", a: "Cliquez sur « Je m'inscris à la formation » ou écrivez-moi via le formulaire de contact. Je reviens vers vous personnellement pour finaliser votre inscription." },
  { q: "Que se passe-t-il si je souhaite plus d'informations ?", a: "Écrivez-moi via le formulaire ou par WhatsApp : je réponds à toutes vos questions avant de vous engager, en toute simplicité." },
];

const CtaPrimary = ({ testid, children = "Découvrir la formation" }) => (
  <Link
    to={CONTACT}
    data-testid={testid}
    className="inline-flex items-center gap-2 rounded-full bg-olive px-8 py-4 text-sm font-medium text-beige-100 transition-all duration-300 hover:bg-olive-dark hover:-translate-y-0.5"
  >
    {children} <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
  </Link>
);

export default function LandingReflexologie() {
  const [openFaq, setOpenFaq] = useState(0);

  useEffect(() => {
    const data = [
      {
        "@context": "https://schema.org",
        "@type": "Course",
        "name": "Formation Réflexologie plantaire",
        "description": "Formation de 5 jours à la réflexologie plantaire avec Julie Zittel, thérapeute et formatrice depuis plus de 25 ans. Cartographie des zones réflexes, qualité du toucher, écoute du pied et déroulement d'une séance. Sans prérequis, très orientée pratique.",
        "provider": { "@type": "Person", "name": "Julie Zittel", "url": "https://juliezittel.com" },
        "url": "https://juliezittel.com/formation-reflexologie-plantaire",
        "hasCourseInstance": {
          "@type": "CourseInstance",
          "courseMode": "onsite",
          "courseWorkload": "PT35H",
          "startDate": "2026-11-23",
          "endDate": "2026-11-28",
          "location": {
            "@type": "Place",
            "name": "Bayonne",
            "address": { "@type": "PostalAddress", "addressLocality": "Bayonne", "postalCode": "64100", "addressCountry": "FR" }
          },
          "offers": {
            "@type": "Offer",
            "price": "1100",
            "priceCurrency": "EUR",
            "availability": "https://schema.org/InStock",
            "url": "https://juliezittel.com/formation-reflexologie-plantaire"
          }
        }
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": FAQ.filter((f) => !f.aRenseigner).map((f) => ({
          "@type": "Question",
          "name": f.q,
          "acceptedAnswer": { "@type": "Answer", "text": f.a }
        }))
      }
    ];
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "reflexo-jsonld";
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
    return () => { document.getElementById("reflexo-jsonld")?.remove(); };
  }, []);

  return (
    <div data-testid="landing-reflexo" className="bg-beige-100 text-ink min-h-screen">
      {/* MINI BARRE */}
      <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-beige-100/85 border-b border-olive-border/60">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid="reflexo-brand" className="flex items-center gap-2">
            <img src="/images/logo-icon.png" alt="" className="h-7 w-7 object-contain" />
            <span className="font-serif text-lg">Julie Zittel</span>
          </Link>
          <div className="flex items-center gap-4">
            <Link to="/formations" data-testid="reflexo-back" className="hidden sm:inline-block text-xs uppercase tracking-[0.2em] text-olive hover:text-olive-dark transition-colors">Toutes les formations</Link>
            <a href={WA} target="_blank" rel="noopener noreferrer" data-testid="reflexo-whatsapp-top" className="inline-flex items-center rounded-full bg-[#25D366] px-4 py-2 text-xs sm:text-sm font-medium text-white transition-transform duration-300 hover:scale-105">
              WhatsApp
            </a>
          </div>
        </div>
      </header>

      {/* SECTION 1 — HERO */}
      <section className="relative min-h-screen flex items-end overflow-hidden" data-testid="reflexo-hero">
        <img src={HERO_IMG} alt="Mains pratiquant la réflexologie plantaire sur un pied — formation réflexologie plantaire à Bayonne" className="absolute inset-0 w-full h-full object-cover" data-testid="reflexo-hero-image" />
        <div className="absolute inset-0 bg-gradient-to-t from-olive-dark/90 via-olive-dark/45 to-olive-dark/10" />
        <div className="relative w-full max-w-6xl mx-auto px-6 pb-24 pt-40">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Formation réflexologie plantaire · Bayonne, Pays Basque</p>
            <h1 className="font-serif text-4xl sm:text-6xl lg:text-7xl font-light leading-[1.08] text-beige-100 max-w-4xl">
              Formation<br />Réflexologie plantaire
            </h1>
            <p className="mt-6 font-serif text-xl sm:text-2xl font-light italic text-beige-200 max-w-2xl">
              Apprendre à lire, toucher et accompagner le corps à travers les pieds.
            </p>
            <p className="mt-5 max-w-xl text-beige-200/90 leading-relaxed">
              Une technique précise, corporelle et intuitive, transmise par Julie Zittel — thérapeute et formatrice depuis plus de 25 ans. Une véritable expérience de terrain, bien au-delà d'une simple succession de protocoles.
            </p>
            <div className="mt-7 flex flex-wrap gap-3 text-sm text-olive-dark">
              <span className="inline-flex items-center rounded-full bg-beige-100/90 px-4 py-2 font-medium">5 jours</span>
              <span className="inline-flex items-center rounded-full bg-beige-100/90 px-4 py-2">Bayonne</span>
              <span className="inline-flex items-center rounded-full bg-beige-100/90 px-4 py-2">Aucun prérequis</span>
              <span className="inline-flex items-center rounded-full bg-gold px-4 py-2 font-medium">4 participants</span>
            </div>
            <div className="mt-9 flex flex-wrap gap-4">
              <CtaPrimary testid="reflexo-cta-hero" />
              <a href={WA} target="_blank" rel="noopener noreferrer" data-testid="reflexo-cta-hero-infos" className="inline-flex items-center gap-2 rounded-full border border-beige-100/50 px-8 py-4 text-sm font-medium text-beige-100 transition-all duration-300 hover:bg-beige-100/10">
                Demander les informations
              </a>
            </div>
          </Reveal>
        </div>
      </section>

      {/* SECTION 2 — POURQUOI APPRENDRE */}
      <section className="py-24 lg:py-28 px-6 max-w-6xl mx-auto" data-testid="reflexo-pourquoi">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-olive mb-4">La réflexologie plantaire</p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-tight">
              Les pieds, une porte d'entrée vers l'écoute du corps
            </h2>
            <p className="mt-7 text-sage leading-relaxed">
              La réflexologie plantaire est une pratique manuelle qui repose sur la stimulation de zones réflexes du pied, dans une approche globale du corps.
            </p>
            <p className="mt-4 text-sage leading-relaxed">
              Utilisée dans une démarche de bien-être, d'accompagnement corporel et de relaxation, elle invite à ralentir, à sentir et à porter au corps une attention différente.
            </p>
            <p className="mt-4 text-sage leading-relaxed">
              Apprendre la réflexologie, c'est apprendre à observer, à toucher et à accompagner — une compétence concrète, précieuse et profondément humaine.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="overflow-hidden rounded-3xl border border-olive-border shadow-[0_25px_50px_-25px_rgba(49,63,21,0.35)]">
              <img src={HERO_IMG} alt="Toucher et stimulation des zones réflexes du pied en réflexologie plantaire" loading="lazy" className="w-full h-[420px] lg:h-[520px] object-cover" />
            </div>
          </Reveal>
        </div>
      </section>

      {/* SECTION 3 — POUR VOUS SI */}
      <section className="pb-24 lg:pb-28 px-6 max-w-6xl mx-auto" data-testid="reflexo-pour-qui">
        <Reveal className="mb-12 max-w-3xl">
          <p className="text-xs uppercase tracking-[0.3em] text-olive mb-4">Pour qui ?</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">Cette formation est pour vous si…</h2>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {POUR_QUI.map((c, i) => (
            <Reveal key={c.label} delay={(i % 3) * 0.08}>
              <div className="h-full flex items-start gap-4 rounded-2xl border border-olive-border bg-beige-50 p-6 transition-colors duration-300 hover:bg-olive-soft/40" data-testid={`reflexo-pourqui-${i}`}>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-olive-soft border border-olive-border">
                  <c.icon className="w-5 h-5 text-olive" strokeWidth={1.5} />
                </span>
                <p className="text-ink leading-snug">{c.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <p className="mt-10 max-w-2xl font-serif text-xl sm:text-2xl font-light italic text-olive-dark leading-relaxed">
            Pas besoin d'être déjà thérapeute pour commencer : cette formation part des bases et vous accompagne pas à pas.
          </p>
        </Reveal>
      </section>

      {/* SECTION 4 — CE QUE VOUS ALLEZ APPRENDRE */}
      <section className="pb-24 lg:pb-28 px-6 max-w-6xl mx-auto" data-testid="reflexo-apprentissages">
        <Reveal className="mb-14 max-w-3xl">
          <p className="text-xs uppercase tracking-[0.3em] text-olive mb-4">Le parcours</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">Ce que vous allez apprendre</h2>
          <p className="mt-6 text-sage leading-relaxed">Un véritable parcours pédagogique, de la découverte à la mise en situation, pensé pour vous rendre progressivement autonome.</p>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
          {APPRENTISSAGES.map((a, i) => (
            <Reveal key={a.title} delay={(i % 4) * 0.07}>
              <div className="border-t-2 border-olive pt-6" data-testid={`reflexo-appr-${i}`}>
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-olive-soft border border-olive-border">
                  <a.icon className="w-5 h-5 text-olive" strokeWidth={1.5} />
                </span>
                <h3 className="mt-5 font-serif text-xl text-ink leading-snug">{a.title}</h3>
                <p className="mt-3 text-sm text-sage leading-relaxed">{a.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <div className="mt-14"><CtaPrimary testid="reflexo-cta-programme" /></div>
        </Reveal>
      </section>

      {/* SECTION 5 — UNE FORMATION AVANT TOUT PRATIQUE */}
      <section className="bg-olive-dark text-beige-100" data-testid="reflexo-pratique">
        <div className="max-w-6xl mx-auto px-6 py-24 lg:py-28 grid lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <div className="overflow-hidden rounded-3xl border border-beige-100/15">
              <img src={PRATIQUE_IMG} alt="Julie pratiquant la réflexologie plantaire sur un pied — apprendre par le toucher pendant la formation" loading="lazy" className="w-full h-[420px] lg:h-[520px] object-cover" />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="text-xs uppercase tracking-[0.3em] text-gold mb-4">La pratique</p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light leading-tight">Une formation avant tout pratique</h2>
            <p className="mt-7 font-serif text-xl sm:text-2xl font-light italic text-beige-200">
              On ne devient pas praticien en regardant faire. On apprend en pratiquant.
            </p>
            <p className="mt-5 text-beige-300/90 leading-relaxed">
              Tout au long de la formation, les participants expérimentent les gestes, reçoivent, donnent, corrigent leur posture et affinent progressivement leur toucher.
            </p>
            <p className="mt-4 text-beige-300/90 leading-relaxed">
              Je vous accompagne à chaque étape de la pratique, pour que chaque geste devienne juste, confiant et incarné.
            </p>
            <div className="mt-8 grid grid-cols-2 gap-3">
              {["Expérimenter", "Recevoir", "Corriger", "Affiner"].map((m) => (
                <span key={m} className="rounded-2xl border border-beige-100/20 bg-beige-100/5 px-4 py-4 text-center text-xs uppercase tracking-[0.2em] text-gold font-medium">{m}</span>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* SECTION 6 — MA PÉDAGOGIE */}
      <section className="py-24 lg:py-28 px-6 max-w-4xl mx-auto text-center" data-testid="reflexo-pedagogie">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-olive mb-4">Ma pédagogie</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-tight">
            Transmettre une technique, c'est aussi transmettre une manière de toucher.
          </h2>
          <p className="mt-8 text-sage leading-relaxed">
            Je transmets bien plus qu'un protocole : mon expérience, ma précision, mon regard, mon ressenti, et les conseils nés de plus de 25 ans de pratique sur le terrain.
          </p>
          <p className="mt-4 text-sage leading-relaxed">
            La formation associe technique, pratique, présence et écoute du corps — car un geste juste naît toujours de la rencontre entre le savoir et la sensibilité.
          </p>
          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-3 max-w-2xl mx-auto">
            {["Technique", "Pratique", "Présence", "Écoute"].map((m) => (
              <span key={m} className="rounded-2xl border border-olive-border bg-beige-50 px-4 py-4 text-center text-xs uppercase tracking-[0.2em] text-olive-dark font-medium">{m}</span>
            ))}
          </div>
        </Reveal>
      </section>

      {/* SECTION 7 — QUI EST JULIE */}
      <section className="pb-24 lg:pb-28 px-6 max-w-6xl mx-auto" data-testid="reflexo-julie">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <div className="overflow-hidden rounded-3xl border border-olive-border shadow-[0_25px_50px_-25px_rgba(49,63,21,0.35)] max-w-md">
              <img src={JULIE_IMG} alt="Julie Zittel, thérapeute et formatrice en réflexologie plantaire depuis plus de 25 ans" loading="lazy" className="w-full h-auto object-cover" />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="text-xs uppercase tracking-[0.3em] text-olive mb-4">Qui suis-je ?</p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">Julie Zittel</h2>
            <p className="mt-3 text-sm uppercase tracking-[0.2em] text-sage">Thérapeute & formatrice depuis plus de 25 ans</p>
            <p className="mt-7 text-sage leading-relaxed">
              J'accompagne depuis plus de 25 ans les personnes à travers différentes approches corporelles, énergétiques et de connaissance de soi.
            </p>
            <p className="mt-4 text-sage leading-relaxed">
              Je transmets aujourd'hui mon expérience à travers des formations conçues pour permettre à chacun d'acquérir de véritables bases pratiques, tout en développant sa propre qualité de présence et de toucher.
            </p>
            <p className="mt-4 text-sage leading-relaxed">
              Mon approche est à la fois exigeante, humaine, intuitive et profondément ancrée dans l'expérience.
            </p>
            <blockquote className="mt-8 border-l-2 border-gold pl-6 font-serif text-xl sm:text-2xl font-light italic text-olive-dark leading-relaxed">
              « Je ne transmets pas seulement des gestes : je transmets une manière d'écouter le corps. »
            </blockquote>
          </Reveal>
        </div>
      </section>

      {/* SECTION 8 — DÉROULEMENT / INFOS PRATIQUES */}
      <section className="py-24 lg:py-28 px-6 max-w-6xl mx-auto" data-testid="reflexo-infos">
        <Reveal className="mb-12 text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-olive mb-4">En pratique</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">Le déroulement de la formation</h2>
        </Reveal>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {INFOS.map((f) => (
            <Reveal key={f.label}>
              <div className={`h-full rounded-2xl border p-6 text-center ${f.aRenseigner ? "border-dashed border-gold bg-gold/10" : "border-olive-border bg-beige-50"}`} data-testid={`reflexo-info-${f.label.toLowerCase()}`}>
                <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-full bg-olive-soft border border-olive-border">
                  <f.icon className="w-5 h-5 text-olive" strokeWidth={1.5} />
                </span>
                <p className="mt-4 text-xs uppercase tracking-[0.2em] text-olive">{f.label}</p>
                <p className={`mt-2 font-serif text-lg leading-snug ${f.aRenseigner ? "text-terracotta" : "text-ink"}`}>{f.value}</p>
                {f.note && <p className="mt-1 text-xs text-sage leading-snug">{f.note}</p>}
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <div className="mt-12 text-center"><CtaPrimary testid="reflexo-cta-infos" children="Je m'inscris à la formation" /></div>
        </Reveal>
      </section>

      {/* SECTION 9 — CE QUE VOUS EMPORTEZ */}
      <section className="pb-24 lg:pb-28 px-6 max-w-6xl mx-auto" data-testid="reflexo-emportez">
        <Reveal className="mb-12 max-w-3xl">
          <p className="text-xs uppercase tracking-[0.3em] text-olive mb-4">Ce que vous emportez</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">Bien plus qu'un contenu technique</h2>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {EMPORTEZ.map((e, i) => (
            <Reveal key={e.title} delay={(i % 3) * 0.08}>
              <div className="h-full rounded-2xl border border-olive-border bg-beige-50 p-7 transition-colors duration-300 hover:bg-olive-soft/40" data-testid={`reflexo-emportez-${i}`}>
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-olive-soft border border-olive-border">
                  <e.icon className="w-5 h-5 text-olive" strokeWidth={1.5} />
                </span>
                <h3 className="mt-5 font-serif text-xl text-ink">{e.title}</h3>
                <p className="mt-2 text-sm text-sage leading-relaxed">{e.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* SECTION 11 — FAQ */}
      <section className="py-24 lg:py-28 px-6 max-w-4xl mx-auto" data-testid="reflexo-faq">
        <Reveal className="mb-12 text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-olive mb-4">FAQ</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">Vos questions</h2>
        </Reveal>
        <div className="space-y-4">
          {FAQ.map((f, i) => (
            <Reveal key={f.q} delay={(i % 4) * 0.05}>
              <button
                type="button"
                onClick={() => setOpenFaq(openFaq === i ? null : i)}
                data-testid={`reflexo-faq-${i}`}
                className="w-full text-left rounded-2xl border border-olive-border bg-beige-50 p-6 transition-colors duration-300 hover:bg-olive-soft/40"
              >
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-serif text-lg sm:text-xl text-olive-dark">{f.q}</h3>
                  <ArrowUpRight className={`w-5 h-5 shrink-0 text-olive transition-transform duration-300 ${openFaq === i ? "rotate-90" : ""}`} strokeWidth={1.5} />
                </div>
                {openFaq === i && (
                  <p className={`mt-4 text-sm leading-relaxed ${f.aRenseigner ? "text-terracotta" : "text-sage"}`}>{f.a}</p>
                )}
              </button>
            </Reveal>
          ))}
        </div>
      </section>

      {/* SECTION 12 — TARIF */}
      <section className="pb-24 lg:pb-28 px-6 max-w-4xl mx-auto" data-testid="reflexo-tarif">
        <Reveal>
          <div className="rounded-3xl border border-olive-border bg-beige-50 p-8 sm:p-14 text-center">
            <p className="text-xs uppercase tracking-[0.3em] text-olive mb-4">Tarif</p>
            <h2 className="font-serif text-3xl sm:text-4xl font-light tracking-tight">Investir dans une véritable compétence</h2>
            <p className="mt-8 text-sm uppercase tracking-[0.2em] text-sage">Tarif de la formation</p>
            <p className="mt-2 font-serif text-5xl sm:text-6xl font-light text-terracotta" data-testid="reflexo-tarif-valeur">{TARIF}</p>
            <div className="mt-8 grid sm:grid-cols-3 gap-4 text-left max-w-2xl mx-auto">
              {[
                { label: "Ce qui est inclus", value: "Les 5 jours de formation, un livret pédagogique et le certificat de fin de formation" },
                { label: "Modalités de paiement", value: "Paiement en 3 fois possible" },
                { label: "Acompte", value: "Acompte de 100 € à l'inscription" },
              ].map((x) => (
                <div key={x.label} className="rounded-2xl border border-olive-border bg-beige-100 p-5">
                  <p className="text-xs uppercase tracking-[0.15em] text-olive">{x.label}</p>
                  <p className="mt-2 text-sm text-sage">{x.value}</p>
                </div>
              ))}
            </div>
            <div className="mt-10"><CtaPrimary testid="reflexo-cta-tarif" children="Je m'inscris à la formation" /></div>
          </div>
        </Reveal>
      </section>

      {/* SECTION 13 — DERNIER CTA */}
      <section className="bg-olive-dark text-beige-100" data-testid="reflexo-cta-final">
        <div className="max-w-4xl mx-auto px-6 py-24 lg:py-28 text-center">
          <Reveal>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light leading-tight">
              Et si vos mains devenaient un nouvel espace d'écoute du corps ?
            </h2>
            <p className="mt-7 text-beige-300/90 leading-relaxed max-w-2xl mx-auto">
              Apprenez la réflexologie plantaire avec Julie Zittel et entrez dans une pratique où la précision du geste rencontre l'écoute et la présence.
            </p>
            <p className="mt-4 text-sm text-gold" data-testid="reflexo-cta-recap">Du 23 au 28 novembre 2026 · Bayonne · 4 participants · Aucun prérequis</p>
            <div className="mt-9 flex flex-wrap justify-center gap-4">
              <Link to={CONTACT} data-testid="reflexo-cta-final-decouvrir" className="inline-flex items-center gap-2 rounded-full bg-beige-100 px-8 py-4 text-sm font-medium text-olive-dark transition-all duration-300 hover:-translate-y-0.5 hover:bg-beige-50">
                Je veux découvrir la formation <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
              </Link>
              <a href={WA} target="_blank" rel="noopener noreferrer" data-testid="reflexo-cta-final-question" className="inline-flex items-center rounded-full border border-beige-100/40 px-8 py-4 text-sm text-beige-100 transition-all duration-300 hover:bg-beige-100/10">
                J'ai une question
              </a>
            </div>
          </Reveal>
        </div>
      </section>

      <footer className="border-t border-olive-border py-6 text-center text-xs text-sage pb-24 lg:pb-6">
        <Link to="/" className="hover:text-olive transition-colors">juliezittel.com</Link> — Thérapeute & formatrice, Bayonne · Pays Basque
      </footer>

      {/* CTA FIXE MOBILE */}
      <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-olive-border bg-beige-100/95 backdrop-blur-md px-4 py-3 pr-24">
        <Link to={CONTACT} data-testid="reflexo-sticky-cta" className="flex w-full items-center justify-center gap-2 rounded-full bg-olive px-6 py-3.5 text-sm font-medium text-beige-100 transition-colors duration-300 hover:bg-olive-dark">
          Découvrir la formation <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
        </Link>
      </div>
    </div>
  );
}
